import { useTranslation } from 'react-i18next'

import type { AccountConnection } from '@/api'
import { GoogleIcon } from '@/components/GoogleIcon'
import { MicrosoftIcon } from '@/components/MicrosoftIcon'
import { SettingsRow } from '@/components/SettingsRow'

type ConnectionRowProps = {
    connection: AccountConnection
    pending: boolean
    disabled: boolean
    onConnect: () => void
}

export const ConnectionRow = ({ connection, pending, disabled, onConnect }: ConnectionRowProps) => {
    const { t } = useTranslation()
    const providerName = t(`security.connections.providers.${connection.provider}`)
    let description = <>{t('security.connections.connectProvider', { provider: providerName })}</>
    let status: string | undefined

    if (connection.connected) {
        status = t('security.connections.connected')
        description = (
            <>
                {connection.email && <span className="block break-all">{connection.email}</span>}
                {!connection.enabled && <span className="mt-1 block">{t('security.connections.unavailable')}</span>}
            </>
        )
    } else if (pending) {
        status = t('security.connections.connecting')
    }

    return (
        <SettingsRow
            icon={connection.provider === 'google' ? <GoogleIcon /> : <MicrosoftIcon />}
            title={providerName}
            description={description}
            status={status}
            statusTone={connection.connected ? 'success' : 'neutral'}
            onAction={connection.connected ? undefined : onConnect}
            actionLabel={t('security.connections.connectProvider', { provider: providerName })}
            disabled={disabled}
            pending={pending}
        />
    )
}
